import { blockEl, unblockEl } from "./Block";
import { createElement } from "../util/utils";

const { __ } = wp.i18n;

export default class ProductVariations {
  constructor(gallery) {
    this.form = document.querySelector('.variations_form');
    let hasVariations = false;

    if (this.form && this.form.dataset.product_variations !== '[]') {
      hasVariations = true;
    }

    if (!this.form || !hasVariations) {
      return;
    }

    this.$variationsForm = $(this.form);
    this.prodId = this.form.dataset.product_id;
    this.title = document.querySelector('#product-title');
    this.sku = document.querySelector('#product_sku');
    this.description = document.querySelector('#product-description');
    this.addToCartWrap = this.form.querySelector('.add-to-cart-item');
    this.addToCartBtn = this.addToCartWrap ? this.addToCartWrap.querySelector('.single_add_to_cart_button') : null;
    this.outOfStockEl = null;
    this.productSwiper = gallery.productGallerySwiper;
    this.thumbSwiper = gallery.thumbsSlider;

    // Gallery Selector
    this.galleryMedium = gallery ? gallery.productGallery : null;
    this.galleryThumbs = gallery ? gallery.thumbs : null;

    // Handlers
    this.addHandlers();
  }

  addHandlers() {
    this.$variationsForm.on('show_variation', this.onShowVariation.bind(this));
  }

  async onShowVariation(event, variation) {
    if (variation === undefined) {
      return;
    }

    blockEl(this.form);
    this.updateQuery(variation);
    this.onCheckProductInStock(variation);
    try {
      let data = {
        action: `palram_get_variation`,
        // eslint-disable-next-line no-undef
        secure: palram.nonces.get_product,
        variation_id: variation.variation_id,
        product_id: this.prodId,
      };
      let response = await this.getProductData(data);
      if (response.success) {
        this.onChangeVariationTitle(response.data);
        this.onChangeVariationDescs(response.data);
        this.onChangeVariationSku(response.data);
        this.onChangeGalleryImage(variation.image);
        this.changeSaleBadge(response.data.saleBadge);
      }
    } catch (e) {
      console.error(e);
    } finally {
      unblockEl(this.form);
    }
  }

  onChangeVariationTitle(data) {
    if (data.title === undefined || !this.title) {
      return;
    }

    this.title.innerHTML = data.title;
  }

  onChangeVariationDescs(data) {
    if (!this.description) {
      return;
    }

    const richWrap = this.description.querySelector('.description-wrapper');
    const shortWrap = this.description.querySelector('.short-description-wrapper');

    if (data.rich && richWrap) {
      richWrap.innerHTML = data.rich
    }

    if (data.short && shortWrap) {
      shortWrap.innerHTML = data.short;
    }
  }

  onChangeVariationSku(data) {
    if (data.sku === undefined || !this.sku) {
      return;
    }

    const skuWrap = this.sku.querySelector('strong')

    if (data.sku && skuWrap) {
      skuWrap.innerHTML = `${__('Model:', 'canopia')} #${data.sku}`;
    } else {
      skuWrap.innerHTML = '';
    }
  }

  onChangeGalleryImage(data) {
    if (!data) {
      return;
    }

    const mdImgs = this.galleryMedium ? this.galleryMedium.querySelectorAll('.variation-image') : null;
    const thImgs = this.galleryThumbs ? this.galleryThumbs.querySelectorAll('.variation-image') : null;
    const sgImg = this.galleryMedium ? this.galleryMedium.querySelector('.woocommerce-product-gallery__single img') : null;

    if (mdImgs.length > 0) {
      for (const mdImg of mdImgs) {
        mdImg.src = data.full_src;
        mdImg.alt = data.title
      }
    } else if(this.productSwiper) {

      let slide = createElement({
        classes: ['swiper-slide'],
      });

      createElement({
        tagname: 'img',
        classes: ['variation-image'],
        attributes: {
          alt: data.title,
          src: data.full_src,
        },
        parent: slide
      });

      this.productSwiper.prependSlide(slide);
    }

    if (thImgs.length > 0) {

      for (const thImg of thImgs) {
        thImg.src = data.gallery_thumbnail_src;
        thImg.alt = data.title
      }
    } else if(this.thumbSwiper) {

      let slide = createElement({
        classes: ['swiper-slide'],
      });

      createElement({
        tagname: 'img',
        classes: ['variation-image'],
        attributes: {
          alt: data.title,
          src: data.gallery_thumbnail_src,
        },
        parent: slide
      });

      this.thumbSwiper.prependSlide(slide);
    }

    if(this.productSwiper) {
      this.productSwiper.slideTo(1);
    }

    if(this.thumbSwiper) {
      this.thumbSwiper.slideTo(1);
    }

    if (sgImg) {
      sgImg.src = data.full_src;
      sgImg.alt = !data.alt ? data.title : data.alt;
    }
  }

  changeSaleBadge(badge) {
    const wrapper = document.querySelector('#product-gallery .sale-badge__wrapper');
    if(wrapper) {
      wrapper.innerHTML = badge ? `<img src="${badge}" alt="">` : '';
    }
  }

  updateQuery(data) {
    const attributesQuery = window.location.search;
    const params = new URLSearchParams(attributesQuery);

    const fields = data.attributes;
    if (fields) {
      for (let field in fields) {
        if (!params.has(field)) {
          document.body.dispatchEvent(new CustomEvent('palram_attribute_changed'));
        }
      }
    }
  }

  onCheckProductInStock(data) {
    if (!this.addToCartWrap) {
      return;
    }

    this.outOfStockEl = document.querySelector('.out-of-stock');
    if (!data.is_in_stock) {
      if (!this.outOfStockEl) {
        this.addToCartWrap.classList.add('d-flex', 'align-items-center', 'variation-is-unavailable');
        this.addToCartBtn.insertAdjacentHTML("afterend", data.availability_html);
      }
    } else {
      if (this.outOfStockEl) {
        this.outOfStockEl.remove();
      }

      if(this.addToCartWrap.classList.contains('variation-is-unavailable')) {
        this.addToCartWrap.classList.remove('d-flex', 'align-items-center', 'variation-is-unavailable');
      }
    }
  }

  async getProductData(data) {
    return $.ajax({
      // eslint-disable-next-line no-undef
      url: palram.ajax_url,
      method: 'GET',
      data,
    });
  }
}
